module.exports = __webpack_public_path__ + "0987c73ee7677261edd37a3853224658.ttf";